import axios from './axiosClient';
import { API_BASE_URL, getBearerHeaders, getBearerJsonHeaders } from './constant';
import { logTokenBeforeRequest } from './setupApiDebugLogging';

const PROFILE_REQUEST_MS = 30000;
const PROFILE_401_RETRY_MS = 500;

export const fetchUserDetails = async (options = {}) => {
  const { signal } = options;
  const url = API_BASE_URL + '/api/user/profile';
  const config = {
    method: 'GET',
    headers: getBearerHeaders(),
    timeout: PROFILE_REQUEST_MS,
    signal,
  };

  try {
    const response = await axios(url, config);
    return response?.data;
  } catch (err) {
    // One retry on 401 reduces random logouts from cold starts, gateways, or transient auth hiccups.
    if (err?.response?.status === 401 && !signal?.aborted) {
      await new Promise((r) => setTimeout(r, PROFILE_401_RETRY_MS));
      if (signal?.aborted) throw err;
      const response2 = await axios(url, {
        ...config,
        headers: getBearerHeaders(),
      });
      return response2?.data;
    }
    throw err;
  }
};

export const addAddressAPI = async (data) => {
  const url = API_BASE_URL + '/api/address';
  try {
    const response = await axios(url, {
      method: 'POST',
      data: data,
      headers: getBearerJsonHeaders(),
    });
    return response?.data;
  } catch (err) {
    throw new Error(err);
  }
};

export const deleteAddressAPI = async (id) => {
  const url = API_BASE_URL + `/api/address/${id}`;
  try {
    const response = await axios(url, {
      method: 'DELETE',
      headers: getBearerHeaders(),
    });
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const updateAddressAPI = async (id, data) => {
  const url = API_BASE_URL + `/api/address/${id}`;
  try {
    const response = await axios(url, {
      method: 'PUT',
      data,
      headers: getBearerJsonHeaders(),
    });
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const fetchOrderAPI = async () => {
  const url = API_BASE_URL + `/api/order/user`;
  try {
    const response = await axios(url, {
      method: 'GET',
      headers: getBearerHeaders(),
    });
    return response?.data;
  } catch (err) {
    throw new Error(err);
  }
};

export const cancelOrderAPI = async (id) => {
  const url = API_BASE_URL + `/api/order/cancel/${id}`;
  try {
    const response = await axios(url, {
      method: 'POST',
      headers: getBearerHeaders(),
    });
    return response?.data;
  } catch (err) {
    throw new Error(err);
  }
};

export async function updateUserInfoAPI(data) {
  const url = `${API_BASE_URL}/api/user/profile`;
  logTokenBeforeRequest('userInfo:PUT /api/user/profile', { url });
  try {
    const response = await axios.put(url, data, {
      headers: getBearerJsonHeaders(),
      timeout: PROFILE_REQUEST_MS,
      validateStatus: (s) => s >= 200 && s < 300,
    });
    return response.data;
  } catch (err) {
    console.error('[userInfo:PUT /api/user/profile]', {
      message: err?.message,
      code: err?.code,
      status: err?.response?.status,
      data: err?.response?.data,
      requestId: err?.config?.headers?.['X-Request-Id'],
    });
    throw err;
  }
}
